import React, { ComponentProps } from 'react';

import CloseButton from '@adsk/alloy-react-close-button';

type Props = ComponentProps<typeof CloseButton>;

const Close = React.forwardRef<HTMLButtonElement, Props>(
  ({ style, className, onClick, showEscapeLabel, ...props }, ref) => {
    return (
      <CloseButton
        {...props}
        ref={ref}
        className={className}
        showEscapeLabel={showEscapeLabel}
        style={[
          {
            marginTop: 4,
            padding: 0,
          },
          style,
        ]}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          onClick && onClick(e);
        }}
      />
    );
  }
);

Close.displayName = 'Close';

Close.propTypes = {
  ...CloseButton.propTypes,
};

export default Close;
